import { CanActivateFn } from '@angular/router';

/**
 * Root landing guard kept for route structure consistency.
 * Internal users should stay on Home so the clients card can render there.
 */
export const internalUserLandingGuard: CanActivateFn = () => true;
